import React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import useGoogleAuth from 'components/useGoogleAuth';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { login } from 'store/authSlice';
interface GoogleUser {
  email: string;
  name: string;
  family_name: string;
  email_verified: boolean;
  picture: string;
  sub: string; // user ID
}

const Login = () => {
   const userStatus = useAppSelector((state:any) => state.auth.isAuthenticated); 
    const dispatch = useAppDispatch(); 
  const navigate = useNavigate()
  const clientId = process.env.REACT_APP_CLIENT_ID;
   useGoogleAuth();
console.log(userStatus, " userStatus on login page")
  if(userStatus){
    navigate('/')
  }


  if (!clientId) { 
    return <div>Error: Google Client ID not found</div>;
  }

  return (
    <div className="py-48 px-4">
      <h2 className="text-2xl mb-4 text-center">Sign in with Google</h2>
      <GoogleOAuthProvider clientId={clientId}>
        <GoogleLogin
          onSuccess={(credentialResponse) => {
          

const token = credentialResponse.credential;

            if (token) {
              const decoded: GoogleUser = jwtDecode(token);
              console.log("decoded?.email", decoded?.email); 
              console.log("decoded?.family_name", decoded?.family_name); 
              console.log("decoded?.email_verified", decoded?.email_verified); 
              console.log("decoded?.picture", decoded?.picture); 
              
              // console.log("✅ Decoded User:", decoded); 
              // localStorage.setItem('gUser',JSON.stringify(decoded))
               dispatch(login(decoded))
              // You now have:
              // decoded.name, decoded.email, decoded.picture, decoded.sub
              // localStorage.setItem('activeCategory', 'homepage');
             
              navigate('/')
              
              console.log("go to home")
            }
          }}
          onError={() => {
            console.log("Login Failed");
          }}
        />
      </GoogleOAuthProvider>
    </div>
  );
};

export default Login;
